module.exports = __webpack_public_path__ + "img/ios.76450cef.svg";